export default ({
  disableEdit,
  disableExecute,
  disableDelete,
  disableDelegate,
  onExecute,
  onEdit,
  onDelegate,
  onDelete,
  setMarkErrandDoneOpen,
  setErrandPaused,
  setErrandActive,
  status,
}) => {
  const result = [
    {
      name: "Utför",
      onClick: onExecute,
      hidden: disableExecute,
    },
  ];

  if (status === 1) {
    result.push({
      name: "Pausa",
      onClick: setErrandPaused,
      hidden: disableExecute,
    });
  }

  if (status === 0 || status === 2) {
    result.push({
      name: "Starta",
      onClick: setErrandActive,
      hidden: disableExecute,
    });
  }

  result.push(
    {
      name: "Redigera",
      onClick: onEdit,
      hidden: disableEdit,
    },
    {
      name: "Delegera ärende",
      onClick: onDelegate,
      hidden: disableDelegate,
    },
    {
      name: "Radera",
      onClick: onDelete,
      hidden: disableDelete,
      isDelete: true,
    }
  );
  if (status !== 3 && status !== 4) {
    result.push({
      name: "Markera som avklarat",
      onClick: () => setMarkErrandDoneOpen(true),
      hidden: disableExecute,
    });
  }

  return result;
};
